import { useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectSelectedTenantId } from "../store/user/selectors";
import { selectChatsState } from "../store/chats/selectors";
import { fetchSummariesByConversationId } from "../store/chats/thunks";

export const useSummaries = () => {
  const dispatch = useDispatch();
  const selectedTenantId = useSelector(selectSelectedTenantId);
  const { chatsByTenants, selectedChatId } = useSelector(selectChatsState);

  const selectedChat = useMemo(() => {
    return chatsByTenants?.[selectedTenantId]?.[selectedChatId];
  }, [selectedChatId, selectedTenantId, chatsByTenants]);

  const fetchSummaries = useCallback(
    (isRefresh) => {
      if (selectedChatId) {
        dispatch(
          fetchSummariesByConversationId({
            conversation_id: selectedChat?.id,
            tenant_id: selectedTenantId,
            isRefresh,
          }),
        );
      }
    },
    [dispatch, selectedChatId, selectedTenantId, selectedChat?.id],
  );

  useEffect(() => {
    if (
      selectedChatId &&
      !selectedChat?.summaries &&
      !selectedChat?.summaryLoading
    ) {
      fetchSummaries();
    }
  }, [selectedTenantId, selectedChatId, selectedChat, dispatch]);

  return {
    loading: selectedChat?.summaryLoading,
    summaries: selectedChat?.summaries || [],
    selectedTenantId,
    selectedChatId,
    fetchSummaries,
  };
};
